export const enterpriseChartPalette = [
  "#2563eb",
  "#4f46e5",
  "#10b981",
  "#f59e0b",
  "#ef4444",
  "#0ea5e9",
  "#7c3aed",
  "#64748b",
];

export const enterpriseChartTheme = {
  colors: enterpriseChartPalette,
  card: {
    background: "linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)",
    border: "1px solid rgba(15, 23, 42, 0.08)",
    radius: 16,
    shadow: "0 10px 30px rgba(15, 23, 42, 0.08)",
  },
  grid: {
    stroke: "#e2e8f0",
    strokeDasharray: "4 4",
  },
  axis: {
    tick: {
      fill: "#64748b",
      fontSize: 12,
      fontWeight: 500,
    },
    label: {
      fill: "#475569",
      fontSize: 12,
      fontWeight: 600,
    },
  },
  tooltip: {
    backgroundColor: "#ffffff",
    border: "1px solid #e2e8f0",
    color: "#0f172a",
    borderRadius: 12,
    boxShadow: "0 12px 30px rgba(15, 23, 42, 0.12)",
  },
  legend: {
    wrapperStyle: {
      paddingTop: 12,
    },
    iconType: "circle",
  },
};

export const formatChartValue = (value) => {
  if (typeof value === "number") {
    if (Math.abs(value) >= 1000) {
      return new Intl.NumberFormat("en-US", {
        maximumFractionDigits: 1,
        notation: "compact",
      }).format(value);
    }
    return new Intl.NumberFormat("en-US", {
      maximumFractionDigits: 2,
    }).format(value);
  }

  if (value instanceof Date) {
    return value.toLocaleDateString();
  }

  return value;
};

export const getChartColor = (index, fallback = enterpriseChartPalette[0]) => {
  return enterpriseChartPalette[index % enterpriseChartPalette.length] || fallback;
};
